'use client';

import { RichText } from '@/components/richText/RichText';
import {
  SwdAccordionHeader,
  SwdAccordionItem,
  SwdAccordionPanel,
  SwdAccordionRoot,
  SwdAccordionTrigger,
} from '@/components/swdAccordion/SwdAccordion';
import type { ComponentStepsStoryblok, PartialStepStoryblok } from '@/types/component-types-sb';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './Steps.module.scss';

type StepProps = {
  step: PartialStepStoryblok;
  style: ComponentStepsStoryblok['style'];
  openFirst?: boolean;
  allOpen?: boolean;
  index: number;
};

const PANEL = 'step';

const Step: FC<StepProps> = (props) => {
  const { step, style, allOpen, openFirst, index } = props;
  const { t } = useTranslation();
  return (
    <div className={classes.step}>
      <div className={classes.stepDecoration} aria-hidden>
        <span className={classes.circle}>{style === 'numbers' && index + 1}</span>
      </div>
      <SwdAccordionRoot
        variant="standard"
        {...(allOpen
          ? { value: [PANEL] as const }
          : { defaultValue: index === 0 && openFirst ? ([PANEL] as const) : [] })}
      >
        <SwdAccordionItem value={PANEL} disabled={!!allOpen}>
          <SwdAccordionHeader>
            <SwdAccordionTrigger
              className={classes.partialAccordionTitle}
              hideExpandIcon={allOpen}
              disabled={allOpen}
              aria-label={t('Schritt') + ' ' + (index + 1) + ': ' + step.title}
            >
              {step.title}
            </SwdAccordionTrigger>
          </SwdAccordionHeader>
          <SwdAccordionPanel>
            <RichText text={step.text} />
          </SwdAccordionPanel>
        </SwdAccordionItem>
      </SwdAccordionRoot>
    </div>
  );
};

export default Step;
